import React from "react";

import OnboardStep from "../OnboardStep";
import ConfirmationCodeEmail from "./ConfirmationCodeEmail";
import ConfirmationCodePhone from "./ConfirmationCodePhone";
import ConfirmationEmail from "./ConfirmationEmail";
import ConfirmationPhone from "./ConfirmationPhone";
import Enrollment from "./Enrollment";
import HaveAccount from "./HaveAccount";

import { ContainerRouter } from "./styles";

const OnboardNewAccount = (props) => {
	return (
		<ContainerRouter>
			<OnboardStep />
			<Pages {...props.location.state} />
		</ContainerRouter>
	);
};

const Pages = (flowPage) => {
	const pages = {
		"confirmation-email": () => <ConfirmationEmail />,
		"confirm-pin-code-create-account-email": () => <ConfirmationCodeEmail {...flowPage} />,
		"confirmation-phone": () => <ConfirmationPhone />,
		"confirm-pin-code-create-account-phone": () => <ConfirmationCodePhone {...flowPage} />,
		"create-account": () => <Enrollment />,
		"user-have-account": () => <HaveAccount {...flowPage} />,
		default: () => <></>,
	};

	const paths = flowPage.param ? flowPage.param : "confirmation-email";

	return (pages[paths] || pages.default)();
};

export default OnboardNewAccount;
